import React from 'react'
import NumberFormat  from 'react-number-format'
import { selectAttachmentGroup } from './AttributeData'

export const convert2Decimal = (value, decimals=2) => {
  decimals = decimals || 0;
  return ( Math.floor( value * Math.pow(10, decimals) ) / Math.pow(10, decimals) );
}

export const numberFormat = (value, allowNegative = false,decimalScale=2) => {
  return (
  <NumberFormat 
    className='centerContent' 
    thousandSeparator=',' 
    value={value} 
    displayType='text'
    decimalScale={decimalScale}
    allowNegative={allowNegative}
    fixedDecimalScale />
  )
}

export const setUpGRPOs = (values) =>{
  let pos = []
  values.goodsServiceReceiptPoItems.forEach((x) => {
    if(Number(x.qtyReceive)){
      if(pos.findIndex(y=>y===x.purchaseOrderSapNumber)<0){
        pos.push(x.purchaseOrderSapNumber)
      }
    }
  })
  return pos
}

export const setUpGRPOItems = (values) =>{
  let poItems = []
  values.goodsServiceReceiptPoItems.forEach(x=>{
    if(Number(x.qtyReceive)){
      poItems.push({
        lineNo:x.lineNo,
        purchaseOrderSapNumber:x.purchaseOrderSapNumber,
        qtyReceive:x.qtyReceive,
        totalNetAmount:x.totalNetAmount,
        adjustAmount:x.adjustAmount,
        totalInvoiceAmount:x.totalInvoiceAmount
      })
    }
  })
  return poItems
}

export const validateAttachments = (values, grTypes, requireMemo=false) => {
  const errors = []
  var vendorCode = values.goodsServiceReceiptPOs[0]?values.goodsServiceReceiptPOs[0].vendorCode:0
  let documentTypes = selectAttachmentGroup(values.mainDeliveryType, values.subDeliveryType, grTypes, vendorCode)
  documentTypes.forEach((dt) => {
    const code = dt.code.toLowerCase()
    if(values.isFromVendor?code!='gr04':true){
      if (code=='gr07'?requireMemo:dt.isRequire) {
        let noFile = false
        let docValue = values[code]
        noFile = (!docValue) || (docValue && !docValue.length)
        if(noFile) {
          const checkDoc = values.goodsServiceReceiptAttachments.filter(a => a.documentCode.toLowerCase() === code && !a.deleted)
          noFile = !checkDoc.length
        }
        if(noFile){
          errors.push({ fieldName: dt.name, message: 'Required!' })
        }
      }
    }
  })
  return errors
}

export const validateField = (values,actionName=null) => {
  let errors = {}
  if(actionName=='Delete'){
    return errors
  }else if(actionName=='Cancel'||actionName=='Revise'){
    if (!values.actionComment) {
      errors.actionComment = 'Required!'
    }
  }else{   
    // if (values.requireSpecialApproval) {
    //   if (!values.specialApprovalId) {
    //     errors.specialApprovalId = 'Required!'
    //   }
    // }
    if (!values.title) {
      errors.title = 'Required!'
    }
    if (values.title && values.title.length > 200) {
      errors.title = 'Title must be less than or equal to 200 characters'
    }
    if (!values.requesterUser) {
      errors.requesterUser = 'Required!'
    }
    if (!values.documentDate) {
      errors.documentDate = 'Required!'
    }
    if (!values.postingDate) {
      errors.postingDate = 'Required!'
    }
    if ((!values.goodsServiceReceiptPOs)||(!values.goodsServiceReceiptPOs.length)) {
      errors.poReleaseList = 'Required!'
    }else{
      let erPoItems = []
      values.goodsServiceReceiptPoItems.every((x, i)=>{
        if(!x.qtyReceive){
          erPoItems[i] = {qtyReceive:'Required!'}
          return true
        }else{
          erPoItems = []
          return false
        }
      })
      if(erPoItems.length){
        errors.goodsServiceReceiptPoItems = erPoItems
      }
    }
    if (values.advancePayment) {
      if (!values.advancePaymentNo) {
        errors.advancePaymentNo = 'Required!'
      }
    }
    if (values.isFinal) {
      if (!values.mainContractTotalValue) {
        errors.mainContractTotalValue = 'Required!'
      }
      if (!values.contractNo) {
        errors.contractNo = 'Required!'
      }
    }
    if (!values.mainDeliveryType) {
      errors.mainDeliveryType = 'Required!'
    }
    if (!values.subDeliveryType) {
      errors.subDeliveryType = 'Required!'
    }
    if (!values.invoiceNumber) {
      errors.invoiceNumber = 'Required!'
    }
    if (!values.invoiceDate) {
      errors.invoiceDate = 'Required!'
    }
  }
  return errors
}

const setStatusActivity = (statusActivity, status) =>{
  let newActivity = statusActivity
  if(status == 0) newActivity='Procurement Process'
  if(statusActivity == 'GOA') newActivity='Procurement Process'
  if(statusActivity == 'Contract System Sign Contract') newActivity='DTGO Legal Process'
  if(statusActivity == 'Contract System') newActivity='DTGO Legal Process'
  if(statusActivity == 'Vendor Accept Contract') newActivity='Vendor Accept Contract'
  if(statusActivity == 'Vendor Signed Contract') newActivity='Vendor Signed Contract'
  if(statusActivity == 'Update Information') newActivity='Procurement Process'
  return newActivity
}

export const checkAlertContract = (valueForm,poDetail) =>{    
  let alert = false
  let msgAlert = []
  valueForm.goodsServiceReceiptPOs.forEach(po => {
    //check gr full resive
    let fullResive = true
    valueForm.goodsServiceReceiptPoItems.filter(f=>f.purchaseOrderSapNumber==po.purchaseOrderSapNumber).forEach(item=>{
      if(fullResive){
        fullResive = (item.qtyRemain - item.qtyReceive) == 0
      }
    })
    //case GR is create by vendor
    if(valueForm.isFromVendor){
      if(fullResive){ //check fullResive
        fullResive = valueForm.goodsServiceReceiptPoItems.length == poDetail.items.length
      }
    }

    let contractInprocess = false
    let contractInprocessList = []
    let mainContractInprocess = false
    let mainContractInprocessObject = {}
    
    //check contract
    po.contracts.forEach(x=>{
      if(x.status!=4 && x.status!=6 && x.status!=8){
        contractInprocess = true
        contractInprocessList.push({documentNumber:x.documentNumber,statusActivity:x.statusActivity,status:x.status})
      }

      if(x.mainContract){
        if(x.status == 0 || x.status == 5 || x.status == 2){
          mainContractInprocess = true
          mainContractInprocessObject.documentNumber = x.documentNumber
          mainContractInprocessObject.statusActivity = x.statusActivity
          mainContractInprocessObject.status = x.status
        }
      }
    })

    if(fullResive && contractInprocess){ //case full resive
      let msgContract = []
      contractInprocessList.sort((a,b)=>{return a.status - b.status})
      contractInprocessList.forEach((x,i)=>{
        if(x.status==0){ //case draft
          msgContract.push(<React.Fragment><strong>has draft contract(s)</strong></React.Fragment>)
        }else{
          msgContract.push(<React.Fragment>{i>0?', ':'has contract no '}<strong>{x.documentNumber}</strong> wait for "<strong>{setStatusActivity(x.statusActivity,x.status)}</strong>"</React.Fragment>)
        }
      })
      msgAlert.push(<React.Fragment>{msgAlert.length>0?<React.Fragment><br/><br/></React.Fragment>:''}PO <strong>{po.purchaseOrderSapNumber}</strong> {msgContract.map(x=>x)}. Please attach the internal memo. If the contract has not been completed, the company has the right not to pay until the contract is completed </React.Fragment>)
      alert = true
    }else if(!po.firstGr && mainContractInprocess){ //case gr #2
      if(mainContractInprocessObject.status==0){
        msgAlert.push(<React.Fragment>{msgAlert.length>0?<React.Fragment><br/><br/></React.Fragment>:''}PO <strong>{po.purchaseOrderSapNumber}</strong>  <strong>has draft contract(s)</strong>. Please attach the internal memo and contact whom concern to update contract status to "Vendor Signed Contract".</React.Fragment>)
      }else{
        msgAlert.push(<React.Fragment>{msgAlert.length>0?<React.Fragment><br/><br/></React.Fragment>:''}Contract No. <strong>{mainContractInprocessObject.documentNumber}</strong> wait for "<strong>{setStatusActivity(mainContractInprocessObject.statusActivity,mainContractInprocessObject.status)}</strong>" . Please attach the internal memo and contact whom concern to update contract status to "Vendor Signed Contract".</React.Fragment>)
      }
      alert = true
    }
  })

  return {alert:alert, msgAlert:msgAlert}
}
